<template>
  <div class="container">
    <div class="modal">
      <transition appear name="slide-resul-volum">
        <div class="modal-container">
          <div class="fecharModal" @click="fecharModal">
            <span>X</span>
          </div>
          <img v-if="sucesso"
            src="../../assets/confir-envio.png"
            alt="imagem de confirmação"
          />
          <img v-else
            src="../../assets/error_image.png"
            alt="imagem de erro"
          />
          <div v-if="sucesso">
            <p>Aquisição registrada com sucesso!</p>
            <p>Os dados serão enviados para o seu e-mail!</p>
          </div>
          <div v-else>
            <p>Não foi possível registrar a solicitação de aquisição dos dados.</p>            
            <p>Tente novamente em alguns instantes, se o problema persistir entre em contato com a Kurier.</p>    
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "FeedbackModal",
  data() {
    return {      
    };
  },

  computed: {},
  props: ["sucesso"],
  methods: {
    fecharModal() {      
      this.$emit("onFecharFeedbackModal")      
    }, 
  },
};
</script>
<style scoped>
.modal::before {
  content: "";
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.644);
  /* background: url("../assets/back-desf.png") no-repeat; */
  z-index: 1;
}
.modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100vh;
  padding: 80px;
  z-index: 2000;
}
.modal-container {
  position: relative;
  background-color: #ffffff;
  text-align: center;
  margin-top: 100px;
  width: 646px;
  height: 349px;
  z-index: 2;
  border-radius: 4px;
}
.modal-container {
  line-height: 4em;
}
.fecharModal {
  position: absolute;
  top: -4px;
  right: 6px;
  color: #001a3f;
  font-size: 2.3em;
  width: 30px;
  cursor: pointer;
}
.modal-container img:nth-child(2) {
  margin-top: 38px;
}
.modal-container p:nth-child(1)
{
  font-size: 1.5em;
  font-weight: bold;
  color: #595959;
}
.modal-container p:nth-child(2) {
  font-size: 1.7em;
  color: #668464;
}
.modal-container p:nth-child(6) {
  background-color: #001a3f;
  margin: 10px auto;
  width: 416px;
  height: 36px;
  color: #c4cad2;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
</style>





